/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_create_drawer_kyc_required_description = /** @type {(inputs: {}) => string} */ () => {
	return `Antes de crear una tarjeta, debes completar el proceso de verificación de identidad (KYC). Este proceso es rápido y seguro.`
};

const en_cards_create_drawer_kyc_required_description = /** @type {(inputs: {}) => string} */ () => {
	return `Before creating a card, you must complete the identity verification (KYC) process. This process is fast and secure.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_create_drawer_kyc_required_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_create_drawer_kyc_required_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_create_drawer_kyc_required_description", locale)
	if (locale === "es") return es_cards_create_drawer_kyc_required_description(inputs)
	return en_cards_create_drawer_kyc_required_description(inputs)
};
export { cards_create_drawer_kyc_required_description as "cards.create_drawer.kyc_required_description" }